import { BaseService } from './BaseService';
import { calculateInsurance, InsuranceRequestInput } from '@/types/graphql/schemaTypes';

// gql
import calculateInsuranceMutation from '@/graphql/mutations/insurance/CalculateInsurance.gql';
import cancelInsuranceMutation from '@/graphql/mutations/insurance/Cancel.gql';
import createInsuranceMutation from '@/graphql/mutations/insurance/Create.gql';
import saveInsurance from '@/graphql/mutations/insurance/SaveInsurance.gql';

class InsuranceService extends BaseService {
  public calculate(form: any) {
    return this.client.mutate<calculateInsurance>({
      mutation: calculateInsuranceMutation,
      variables: {
        form: JSON.stringify(form)
      }
    });
  }

  public create(shipmentId: string, form: any) {
    return this.client.mutate({
      mutation: createInsuranceMutation,
      variables: {
        shipmentId,
        form: JSON.stringify(form)
      }
    });
  }

  public cancel(shipmentId: string) {
    return this.client.mutate({
      mutation: cancelInsuranceMutation,
      variables: {
        shipmentId
      }
    });
  }

  public save(shipmentId: string, form: InsuranceRequestInput) {
    return this.client.mutate({
      mutation: saveInsurance,
      variables: {
        shipmentId,
        form
      }
    });
  }
}

export const insuranceService = new InsuranceService();
